import type { ReactNode } from 'react';
import { Button } from '@/components/ui/button';

/**
 * RAD Finance — helpers de página (PageHeader / PageBody)
 * --------------------------------------------------------------------------
 * O shell autenticado vive em `components/layout/AppLayout.tsx` (Sidebar +
 * Topbar). Este módulo mantém apenas os helpers de página consumidos pelas
 * telas — restilizados com os tokens do design system RAD — e re-exporta o
 * Button por conveniência (compatibilidade com imports existentes).
 */

interface PageHeaderProps {
  title: string;
  breadcrumb?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, breadcrumb, actions }: PageHeaderProps) {
  return (
    <header className="px-6 py-4 border-b border-line bg-surface flex items-center justify-between">
      <div className="min-w-0">
        {breadcrumb && (
          <div className="text-xs uppercase tracking-[0.14em] text-faint">{breadcrumb}</div>
        )}
        <h1 className="text-lg font-semibold text-fg truncate">{title}</h1>
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </header>
  );
}

export function PageBody({ children }: { children: ReactNode }) {
  return <div className="p-6 space-y-4">{children}</div>;
}

// Re-export para conveniência (compatibilidade com imports existentes).
export { Button };
